<script>
    export default {
        inserted: function (el) {
            let controls = el.querySelectorAll("li[data-type='step']");
            let prev = el.querySelector("li[data-type='prev']");
            let next = el.querySelector("li[data-type='next']");
            let pause = false;


            let rows = el.querySelectorAll('.row');
            let current = 0;

            let setOnClick = function (element, index) {
                element.onclick = function (e) {
                    pause = true;
                    for (let i = 0; i < controls.length; i++) {
                        controls[i].classList.remove('active');
                        rows[i].style.display = 'none';
                    }

                    for (let i = 0; i < controls.length; i++) {
                        if (i === index) {
                            current = index;
                            controls[i].classList.add('active');
                            rows[i].style.display = 'flex';
                        }
                    }
                }
            }
            for (let i = 0; i < controls.length; i++) {
                setOnClick(controls[i], i);
            }

            next.onclick = function () {
                pause = true;
                slideTo(current + 1);
            }

            prev.onclick = function () {
                pause = true;
                slideTo(current - 1);
            }

            let slideTo = function (index) {

                if ((index >= 0) && (index < controls.length)) {
                    for (let i = 0; i < controls.length; i++) {
                        controls[i].classList.remove('active');
                        rows[i].style.display = 'none';
                    }

                    for (let i = 0; i < controls.length; i++) {
                        if (i === index) {
                            current = index;
                            controls[i].classList.add('active');
                            rows[i].style.display = 'flex';
                        }
                    }
                }

            }

            setInterval(function () {
                if ((current + 1) < controls.length) {
                    if (!pause) {
                        slideTo(current + 1);
                    }
                } else {
                    if (!pause) {
                        slideTo(0);
                    }
                }
            }, 5000);

        }
    }

</script>
